import Vue from 'vue';

// State object
const state = {
  list: {
    bonusCondition: false,
    aboutAge: false,
  },
  config: {
    showLogin: false,
  },
};

// Mutations
const mutations = {
  openDialog(state, name) {
    Vue.set(state.list, name, true);
  },
  closeDialog(state, name) {
    Vue.set(state.list, name, false);
  },
  setConfig(state, config) {
    if (config) {
      // settings.json から読み込んだ設定をアプリに反映
      // showLogin: false = 募集期間外メッセージを表示
      //           true = WEB募集のログイン画面を表示
      // settings.json で "true"/"false" と文字列で記載されている可能性があるため、
      // 文字列の場合は boolean 値に変換して正しく判定できるようにする
      const showLogin = config.showLogin;
      const normalized = typeof showLogin === 'string'
        ? showLogin.toLowerCase() === 'true'
        : showLogin;
      Vue.set(state, 'config', { ...config, showLogin: normalized });
    }
  },
};

// Actions
const actions = {
  openDialog({ commit }, name) {
    commit('openDialog', name);
  },
  closeDialog({ commit }, name) {
    commit('closeDialog', name);
  },
  setConfig({ commit }, config) {
    commit('setConfig', config);
  },
};

// Getters
const getters = {
  webShowLogin: (state) => state.config?.showLogin ?? false,
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
